<template>
    <div class="teaser">
        <div class="teaser-background-images">
            <div
                v-for="(img, index) in this.imgs"
                :key="`id-` + index + 1"
                :class="`teaser-img-box img-${index}`"
                :style="{ 'background-image': `url(${require(`@/assets/imgs/teaser-background/${img}`)})` }"
            >
                <!-- <img :src="require(`@/assets/imgs/teaser-background/${img}`)" /> -->
            </div>
        </div>
        <div class="tesaser-background-gradient"></div>
        <div class="teaser-part">
            <template
                v-for="(section, index) in this.section"
                v-bind:key="`title-${index}`"
            >
                <div
                    class="teaser-title-container"
                    :ref="`title-${index}`"
                >
                    <h2>
                        <!-- <div :data-title="section.title"></div> -->
                        <div v-html="section.title"></div>
                    </h2>
                </div>
                <div
                    class="teaser-number-container"
                    :ref="`number-${index}`"
                >
                    <div :class="`numbers numbers-${index}`">
                        <div
                            class="number-container"
                            v-for="number in section.numbers"
                            :key="section.numbers[number]"
                        >
                            <div class="top-side">
                                <template v-if="number.type == 'unit-contain-1' && number.type !== 'unit-contain-2'">
                                    <span
                                        class="number"
                                        data-count="13"
                                        >213</span
                                    >
                                    <span
                                        class="unit"
                                        style="margin-right: 1em"
                                        >시간</span
                                    >
                                    <span
                                        class="number"
                                        data-count="3379"
                                        >43</span
                                    >
                                    <span class="unit">분</span>
                                </template>
                                <template v-if="number.type == 'unit-contain-2' && number.type !== 'unit-contain-1'">
                                    <span
                                        class="number"
                                        data-count="13"
                                        >13</span
                                    >
                                    <span
                                        class="unit"
                                        style="margin-right: 1em"
                                        >조</span
                                    >
                                    <span
                                        class="number"
                                        data-count="3379"
                                        >3,379</span
                                    >
                                    <span class="unit">억원</span>
                                </template>
                                <template v-if="number.type !== 'unit-contain-1' && number.type !== 'unit-contain-2'">
                                    <span
                                        class="number"
                                        :data-count="number.number"
                                        v-html="number.number"
                                    ></span>
                                    <span
                                        class="unit"
                                        v-html="number.unit"
                                    ></span>
                                </template>
                            </div>
                            <div
                                class="bottom-side caption"
                                v-html="number.caption"
                            ></div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import counterUp from 'counterup2';

export default {
    name: 'TeaserSection',
    data() {
        return {
            randoms: [],
            imgs: [],
            section: [
                {
                    key: 1,
                    title: `서울<br> 면적의<br>3분의 1이<br> 불탔다`,
                    numbers: [
                        {
                            number: `20,928`,
                            unit: `ha`,
                            caption: `산불 피해면적 (서울 면적의 34.6%)`,
                        },
                        {
                            number: `6,447`,
                            unit: `명`,
                            caption: `주민대피`,
                        },
                        {
                            number: `337`,
                            unit: `명`,
                            caption: `이재민`,
                        },
                    ],
                },
                {
                    key: 2,
                    title: `정부 수립 이래<br> 가장 <br> 오랫동안 <br> 탄 산불`,
                    numbers: [
                        {
                            number: `12,823`,
                            unit: `분`,
                            caption: `진화 소요 시간`,
                        },
                        {
                            type: 'unit-contain-1',
                            number: `213시간 43분`,
                            unit: `억원`,
                            caption: `진화 소요 시간`,
                        },
                    ],
                },
                {
                    key: 3,
                    title: `총력전으로도<br> 막지 못한<br> 산불`,
                    numbers: [
                        {
                            number: `69,698`,
                            unit: `명`,
                            caption: `진화 인력(연인원)`,
                        },
                        {
                            number: `7,392`,
                            unit: `대`,
                            caption: `투입 헬기, 장비 누적 대수`,
                        },
                    ],
                },
                {
                    key: 4,
                    title: `5년치 <br>산림 예산<br> 한순간에 <br>날렸다`,
                    numbers: [
                        {
                            number: `8,811`,
                            unit: `억원`,
                            caption: `산불 직접 피해액 <br>
                                        (임목피해 + 공익평가액)`,
                        },
                        {
                            type: 'unit-contain-2',
                            number: `13조 3,790억 원`,
                            unit: `억원`,
                            caption: `자산 보호 평가액 <br>
                        (금강소나무의 경제적 <br>
                        가치에 대한 연구, 2015)<br>
                        <span class='adexp'>※ 2022년 산림청 예산 : 2조 3,903억 원 </span>
`,
                        },
                    ],
                },
            ],
        };
    },
    methods: {
        pushImgs() {
            for (let i = 0; i < 170; i++) {
                this.imgs.push(`img_${i}.jpg`);
            }
        },
        countUp(el) {
            console.log();
            const numbers = el.querySelectorAll('.number');
            numbers.forEach((number) => {
                counterUp(number, {
                    duration: 2000,
                    delay: 16,
                });
            });
        },
    },
    mounted() {
        const _self = this;
        _self.pushImgs();
        this.MultiLingual('article h2');
        this.MultiLingual('.teaser-title-container h2 div');
    },
    updated() {
        this.ScrollReveal().reveal('.number-container', { origin: 'left', reset: true, duration: 1000, distance: '-3em', beforeReveal: this.countUp });
        this.ScrollReveal().reveal('.teaser-title-container h2 div', { origin: 'left', reset: true, duration: 1000, distance: '-3em' });
    },
};
</script>
<style lang="scss" scoped>
.teaser {
    font-size: 50px;
    color: $white;
    text-align: center;
    position: relative;
    height: 1400vh;
    background: black;
    .tesaser-background-gradient {
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgb(50, 50, 50);
        background: linear-gradient(360deg, rgba(50, 50, 50, 1) 0%, rgba(50, 50, 50, 0) 25%);
    }
    .teaser-background-images {
        width: 100%;
        height: 100%;
        top: 0;
        position: absolute;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        justify-content: center;
        align-items: flex-start;
        z-index: 0;
        overflow: hidden;
        background: $black;

        .teaser-img-box {
            position: relative;
            display: inline-block;
            justify-self: center;
            left: 0;
            z-index: 0;
            display: flex;
            mix-blend-mode: darken;
            width: 100%;
            height: 100%;
            background-size: cover;
            aspect-ratio: 1.4;
            img {
                object-fit: cover;
                width: 100%;
                filter: grayscale(1);
                position: relative;
                z-index: -1;
            }
        }
    }

    .teaser-part {
        font-size: 65px;
        line-height: 1.1;

        .teaser-title-container {
            min-height: 150vh;
            h2 {
                position: sticky;
                top: 0;
                font-size: 50px;
                min-height: 100vh;

                display: flex;
                justify-content: center;
                align-items: center;
                div {
                    background: black;
                    padding: 20px;
                }
            }
        }

        .teaser-number-container {
            min-height: 200vh;
            .numbers {
                position: sticky;
                top: 0;
                z-index: 1;
                min-height: 100vh;
                display: flex;
                justify-content: center;
                flex-direction: column;
                .number-container {
                    max-width: 450px;
                    width: 100%;
                    margin: 0 auto;
                    padding: 10px;
                    background: black;
                    .top-side {
                        border-bottom: 2px solid $white;
                        padding-bottom: 10px;
                        .number {
                            padding: 0;
                            font-family: miller-display, serif;
                            font-size: 80px;
                        }
                        .unit {
                            font-size: 20px;
                            padding-left: 10px;
                        }
                    }
                    .bottom-side {
                        padding-top: 10px;
                        font-size: 20px;
                        font-weight: 600;
                        line-height: 1.35;
                        :deep(.adexp) {
                            opacity: 0.5;
                            font-size: 0.7em;
                        }
                    }
                }
            }
        }
    }
}

@media all and (max-width: 800px) {
    .teaser {
        .teaser-background-images {
            grid-template-columns: 1fr 1fr;
        }
        .teaser-part {
            overflow-x: hidden;
            .teaser-title-container {
                h2 {
                    font-size: 30px;
                }
            }
            .teaser-number-container {
                .numbers {
                    padding: 30px;
                    .number-container {
                        max-width: 300px;
                        .top-side {
                            display: flex;
                            justify-content: center;
                            align-items: flex-end;

                            .number {
                                font-size: 40px;
                                line-height: 1;
                            }
                            .unit {
                                font-size: 15px;
                            }
                        }
                        .bottom-side {
                            font-size: 15px;
                        }
                    }
                }
            }
        }
    }
}
</style>
